module.exports = __webpack_public_path__ + "static/coming_soon-95fbf9b98207288dd152ede2538639bb.svg";